import React from "react";
import { useNavigate } from "react-router-dom";
import Pages from "@client.enums/pages";
import Icon from "@client.components/Icon";
import { NavImgLink } from "@client.components/NavImgLink/NavImgLink";
import usePermission from "@client.hooks/usePermission";
import "./NavigationBar.scss";

export const NavigationBar = () => {
  const { isAllowed } = usePermission();
  const navigate = useNavigate();

  const topBarItems = [
    {
      icon: "dashboard",
      url: Pages.Dashboard,
      name: "components.NavigationBar.dashboard",
    },
  ];

  if (isAllowed()) {
    topBarItems.push({
      icon: "reports",
      url: Pages.Reports,
      name: "components.NavigationBar.reports",
    });
  }

  return (
    <div className="navigation-bar" data-testid="NavigationBar">
      <div className="top">
        <Icon
          name="logo"
          className="logo"
          isSvg={true}
          onClick={() => navigate(Pages.Dashboard)}
        />
        <div className="top-bar-items">
          {topBarItems.map((item) => (
            <NavImgLink
              key={item.name}
              icon={item.icon}
              showTitle={true}
              translationKey={item.name}
              url={item.url}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
